import { render, staticRenderFns } from "./RootMenuView.vue?vue&type=template&id=62a2ba04"
import script from "./RootMenuView.vue?vue&type=script&lang=ts"
export * from "./RootMenuView.vue?vue&type=script&lang=ts"
import style0 from "./RootMenuView.vue?vue&type=style&index=0&id=62a2ba04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports